export default "__VITE_ASSET__BoseYULt__"